import { render, staticRenderFns } from "./SuperkidRegistration.vue?vue&type=template&id=8176c5e6&scoped=true&"
import script from "./SuperkidRegistration.vue?vue&type=script&lang=js&"
export * from "./SuperkidRegistration.vue?vue&type=script&lang=js&"
import style0 from "./SuperkidRegistration.vue?vue&type=style&index=0&id=8176c5e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8176c5e6",
  null
  
)

export default component.exports